import { CSSProperties } from 'react';

import { DOTTED_SVG, FLARE_BG } from 'molecules/Section/styles/flareBackgrounds';

interface GetBackgroundStyleProps {
  flareBackground?: boolean;
  flareBackgroundTop?: boolean;
  dottedBackground?: boolean;
}

export const getBackgroundStyle = ({
  flareBackground,
  flareBackgroundTop,
  dottedBackground,
}: GetBackgroundStyleProps): CSSProperties | undefined => {
  if (flareBackground && dottedBackground) {
    return {
      backgroundImage: `url("${DOTTED_SVG}"), url("${FLARE_BG}"), radial-gradient(43.2% 36.09% at 12.43% 69.01%, rgba(10, 19, 181, 0.17) 0%, rgba(10, 19, 181, 0) 100%),
    radial-gradient(72.42% 52.17% at 95.9% 69.09%, rgba(10, 19, 181, 0.17) 0%, rgba(10, 19, 181, 0) 100%),
    radial-gradient(33.26% 34.57% at 100% 74.26%, rgba(46, 206, 149, 0.13) 0%, rgba(46, 206, 149, 0) 100%),
    radial-gradient(44.46% 40.87% at 6.94% 74.52%, rgba(46, 206, 149, 0.13) 0%, rgba(46, 206, 149, 0) 100%),
    radial-gradient(45.33% 42.13% at 45.38% 73.7%, rgba(155, 160, 255, 0.17) 0%, rgba(10, 19, 181, 0) 100%),
    radial-gradient(28.1% 26.05% at 75.03% 61.99%, rgba(174, 178, 255, 0.13) 0%, rgba(10, 19, 181, 0) 100%),
    linear-gradient(0deg, #101017, #101017)`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    };
  }

  if (flareBackground) {
    return {
      backgroundImage: `url("${FLARE_BG}"), radial-gradient(43.2% 36.09% at 12.43% 69.01%, rgba(10, 19, 181, 0.17) 0%, rgba(10, 19, 181, 0.00) 100%), radial-gradient(72.42% 52.17% at 95.9% 69.09%, rgba(10, 19, 181, 0.17) 0%, rgba(10, 19, 181, 0.00) 100%), radial-gradient(33.26% 34.57% at 100% 74.26%, rgba(46, 206, 149, 0.13) 0%, rgba(46, 206, 149, 0.00) 100%), radial-gradient(44.46% 40.87% at 6.94% 74.52%, rgba(46, 206, 149, 0.13) 0%, rgba(46, 206, 149, 0.00) 100%), radial-gradient(45.33% 42.13% at 45.38% 73.7%, rgba(155, 160, 255, 0.17) 0%, rgba(10, 19, 181, 0.00) 100%), radial-gradient(28.1% 26.05% at 75.03% 61.99%, rgba(174, 178, 255, 0.13) 0%, rgba(10, 19, 181, 0.00) 100%), linear-gradient(0deg, #101017, #101017)`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    };
  }

  if (flareBackgroundTop) {
    return {
      backgroundImage: `url("${FLARE_BG}")`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    };
  }

  return undefined;
};
